module.exports = __webpack_public_path__ + "img/PlantIt boardHeader.8da38ea2.png";